// Cross-tab "the jwt cookie changed" signal.
//
// Every tab shares the `jwt` cookie, but each tab holds its own socket, whose
// handshake token is frozen for the life of the connection. When one tab signs
// in, signs out or becomes a different user, the others have to be told, or
// their sockets keep the old identity (and the staff room it earned) until their
// next `register`. Cookies fire no event, so the signal is a localStorage write:
// the `storage` event reaches every OTHER same-origin tab (never the writer).
//
// The value carries no identity — only "go re-read the cookie".
export const AUTH_CHANGE_STORAGE_KEY = 'timbercloud-auth-change';

// Call right after any code path sets or removes the `jwt` cookie.
export function publishAuthChange() {
  if (typeof window === 'undefined') return;
  try {
    // Must differ every time: writing an unchanged value fires no event.
    localStorage.setItem(
      AUTH_CHANGE_STORAGE_KEY,
      `${Date.now()}:${Math.random().toString(36).slice(2)}`
    );
  } catch (e) {
    // Storage unavailable: other tabs catch up on their next register.
  }
}

export function subscribeToAuthChange(onChange) {
  if (typeof window === 'undefined') return () => {};
  const handler = (event) => {
    if (event.key === AUTH_CHANGE_STORAGE_KEY) onChange(event);
  };
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}
